
// export const SET_POSTAL_CODE = 'SET_POSTAL_CODE';
export const ADD_SELECTED_INTEREST = 'ADD_SELECTED_INTEREST';
export const ADD_SELECTED_SKILL = 'ADD_SELECTED_SKILL';
export const LOGOUT = 'LOGOUT';
export const REMOVE_SELECTED_INTEREST = 'REMOVE_SELECTED_INTEREST';
export const REMOVE_SELECTED_SKILL = 'REMOVE_SELECTED_SKILL';
export const SET_FORM_DATA = "SET_FORM_DATA";
export const ADD_LIKED_JOB = "ADD_LIKED_JOB";
export const REMOVE_LIKED_JOB = "REMOVE_LIKED_JOB";

export const logout = () => ({
  type: LOGOUT,
});

// export const setPostalCode = (postalCode) => ({
//   type: SET_POSTAL_CODE,
//   payload: postalCode,
// });

export const addSelectedInterest = (interest) => ({
  type: ADD_SELECTED_INTEREST,
  payload: interest,
});

export const addSelectedSkill = (skill) => ({
  type: ADD_SELECTED_SKILL,
  payload: skill,
});

export const removeSelectedInterest = (interest) => ({
    type: REMOVE_SELECTED_INTEREST,
    payload: interest,
  });
  
  export const removeSelectedSkill = (skill) => ({
    type: REMOVE_SELECTED_SKILL,
    payload: skill,
  });
  export const setFormData = (formData) => ({
    type: SET_FORM_DATA,
    payload: formData,
  });
  export const addLikedJob = (job) => ({
  type: ADD_LIKED_JOB,
  payload: job,
});

export const removeLikedJob = (jobId) => ({
  type: REMOVE_LIKED_JOB,
  payload: jobId,
});
